// ==========================================================================
// Roster module
// ==========================================================================
import AbstractModule from './AbstractModule';
import {selectricDecorator} from '../ractive/ractive-decorators-selectric';
import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';
import {$document, $body} from '../utils/environment';


export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.$el      = options.$el;
        this.$filters = this.$body.find('.js-filters');

        // Ractive style.
        this.template  = null;
        this.partials  = null;
        this.$document = $document;

        this.team        = options.team;

        this.currentYear = this.$body.find('.selectric-js-year').find(':selected').val();
        this.positionFilter = this.$body.find('.selectric-js-playing-positions');

        // Don'T load twice.
        this.fetchingTemplate = false;

        // Ractive instance
        this.ractiveInstance = null;
        this.ractiveLoading  = false;

        this.init();
    }

    // ==========================================================================
    // Initialisation
    // ==========================================================================

    init() {
        this.events()
    }

    ractive(cb) {
        if (this.ractiveLoading === true) {
            return;
        }

        this.loading();

        if (!this.template) {
            this.fetchTemplate(() => {
                this.ractiveLoading = false;
                this.ractive(cb)
            });
            return this;
        }

        if (this.ractiveInstance) {
            this.loaded();

            if (typeof cb === 'function') {
                cb();
            }
            return this;
        }

        let self             = this;
        let domList          = this.$el.eq(0);
        this.ractiveInstance = new Ractive({
            el         : domList,
            template   : this.template,
            partials   : this.partials,
            events     : {tap},
            transitions: {fade},
            decorators : {
                selectric: selectricDecorator
            },
            data       : {
                athletes: [],
                loading : true
            },
            oninit     : (options) => {
            },
            onrender   : () => {
                window.App.initModules(self.$el);
                self.$document.trigger({
                    type     : 'rebuild.Scroll',
                    scrollTop: false
                });
                self.loaded();
            }
        });

        if (typeof cb === 'function') {
            cb();
        }
    }

    filter(type, value) {
        if (!this.ractiveInstance) {
            this.ractive(() => {
                this.filter(type, value)
            });
            return false;
        }

        switch (type) {
            case 'position':
                let athletes = this.ractiveInstance.get('athletes');
                if (!athletes.length) {
                    this.fetchRoster(this.currentYear, () => {
                        this.filter(type, value)
                    })
                }

                // Filter the positions
                for (let i = 0; i < athletes.length; i++) {
                    if (athletes[i]['playingPositionFull'] === value || value === '') {
                        this.ractiveInstance.set('athletes.' + i + '.filteredOut', false);
                    } else {
                        this.ractiveInstance.set('athletes.' + i + '.filteredOut', true);
                    }
                }

                break;
            case 'year':
                this.fetchRoster(value);

                if (value === this.currentYear) {
                    this.positionFilter.removeClass('u-hidden');
                } else {
                    this.positionFilter.addClass('u-hidden');
                }
                break;
        }
    }

    // ==========================================================================
    // QUERIES
    // ==========================================================================


    fetchTemplate(cb) {
        if (this.template) {
            return this;
        }

        if (this.fetchingTemplate) {
            return this;
        }

        this.fetchingTemplate = true;

        $.get('template', {template: 'volleyball/template/partial/components/athletes/athletes-profile'}, (response) => {
            this.fetchingTemplate = false;
            if (response.success) {
                this.template = response.template;
                this.partials = response.partials;
                if (typeof cb === 'function') {
                    cb();
                }
            }
        }, 'json');

        return this;
    }

    fetchRoster(year, cb) {
        let data = {
            year: year,
            team: this.team
        };

        $.get('roster', data, (response) => {
            if (response.success) {
                this.ractiveInstance.set('athletes', response.athletes);
                if (typeof cb === 'function') {
                    cb();
                }
            }
        }, 'json');
    }

    // ==========================================================================
    // Event Listeners
    // ==========================================================================

    events() {
        this.$body.on('change.Roster', '.js-filters', (e) => {
            let $element = $(e.currentTarget);
            let index    = this.$filters.index($(e.currentTarget));
            let val      = $element.find(':selected').val();

            switch (index) {
                case 0:
                    this.filter('year', val);
                    break;
                case 1:
                    this.filter('position', val);
                    break;
            }
        });
    }

    // Trigger loading animation and styles
    loading() {
        this.ractiveLoading = true;
        this.$el.addClass('is-loading');

        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', true);
        }
    }

    // Trigger loaded animation and styles
    loaded() {
        this.ractiveLoading = false;
        this.$el.removeClass('is-loading');
        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', false);
        }
    }

    destroy() {
        if (this.ractiveInstance) {
            this.ractiveInstance.teardown();
        }
        this.$el.off('.Roster');
    }
} 
